import { Col, Form, Row } from "react-bootstrap";
import ColorInput from "../ColorInput";
import ColorPickerAdd from "../ColorPickerAdd";
import ColorPickerClose from "../ColorPickerClose";
import FileInput from "../FileInput";

const PopupSettings = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = () => {
    setFormData((prev) => ({
      ...prev,
      popup: {
        ...prev.popup,
        bgColor: [...prev.popup.bgColor, "#000000"],
      },
    }));
  };

  const removeBgColor = (index) => {
    setFormData((prev) => {
      const updatedBgColors = prev.popup.bgColor.filter((_, i) => i !== index);
      return {
        ...prev,
        popup: {
          ...prev.popup,
          bgColor: updatedBgColors,
          bgOrientation:
            updatedBgColors.length === 1 ? null : prev.popup.bgOrientation,
        },
      };
    });
  };

  return (
    <Row>
      <Col md={3} sm={12}>
        <Form.Group>
          <Form.Label htmlFor="bgType">Background Type</Form.Label>
          <Form.Select
            name={`popup.bgType`}
            value={formData.popup.bgType || "color"}
            onChange={onInputChange}
            className="my-2"
          >
            <option value="color">Color</option>
            <option value="image">Image</option>
          </Form.Select>
        </Form.Group>
      </Col>
      <Col lg={3} sm={12}>
        <ColorInput
          label="Text Color"
          name="popup.textColor"
          value={formData.popup.textColor}
          onChange={onInputChange}
        />
      </Col>
      {formData.popup.bgType === "color" && (
        <>
          <Col lg={3} sm={12}>
            <div className="d-flex align-items-center gap-4">
              <Form.Label>Background Color</Form.Label>
              <ColorPickerAdd addBgColor={addBgColor} />
            </div>
            <div className="d-flex align-items-center gap-3">
              {formData.popup.bgColor.map((color, index) => (
                <div key={index} className="position-relative">
                  <ColorInput
                    id={index}
                    name="popup.bgColor"
                    value={color}
                    data-index={index}
                    onChange={onInputChange}
                  />
                  {formData.popup.bgColor.length > 1 && (
                    <ColorPickerClose
                      removeBgColor={removeBgColor}
                      index={index}
                    />
                  )}
                </div>
              ))}
            </div>
          </Col>
          {formData.popup.bgColor.length > 1 && (
            <Col lg={3} sm={12}>
              <Form.Group>
                <Form.Label htmlFor="bgOrientation">
                  Select Gradient Orientation
                </Form.Label>
                <Form.Select
                  value={formData.popup.bgOrientation}
                  name="popup.bgOrientation"
                  id="popup.bgOrientation"
                  onChange={onInputChange}
                  className="my-2"
                  required={formData.popup.bgColor.length > 1}
                >
                  <option value="">Select Orientation</option>
                  {gradientOptions.map((orientation) => (
                    <option key={orientation.value} value={orientation.value}>
                      {orientation.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Select any one gradient variant
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          )}
        </>
      )}
      <Col lg={3} sm={12} />
      {formData.popup.bgType === "image" && (
        <>
          <Col lg={6} sm={12}>
            <FileInput
              label="Popup Background Image"
              name="popupBgImage"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.popupBgImage}
              accept="image/*"
              isInvalid={validate && !files.popupBgImage}
              feedback="Upload a popup background image."
            />
          </Col>
          <Col lg={6} sm={12}>
            <FileInput
              label="Popup Side Background Image"
              name="popupBgSideImage"
              onChange={handleFileChange}
              required={true}
              fileName={fileNames.popupBgSideImage}
              accept="image/*"
              isInvalid={validate && !files.popupBgSideImage}
              feedback="Upload a popup side background image."
            />
          </Col>
        </>
      )}
      <Col lg={3} sm={12}>
        <ColorInput
          label="Accent Key Background Color"
          name="popup.accentKeyBGColor"
          value={formData.popup.accentKeyBGColor}
          onChange={onInputChange}
        />
      </Col>
      <Col lg={3} sm={12}>
        <ColorInput
          label="Accent Key Text Color"
          name="popup.accentKeyTextColor"
          value={formData.popup.accentKeyTextColor}
          onChange={onInputChange}
        />
      </Col>
    </Row>
  );
};

export default PopupSettings;
